import { render, staticRenderFns } from "./AdminComments.vue?vue&type=template&id=0e23249b&"
import script from "./AdminComments.vue?vue&type=script&lang=js&"
export * from "./AdminComments.vue?vue&type=script&lang=js&"
import style0 from "./AdminComments.vue?vue&type=style&index=0&id=0e23249b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports